module.exports = __webpack_public_path__ + "media/images/icons/logomark-ab3dade27d393df532ddac7df7784a6d.svg";